import React from 'react';
import createSvgIcon from '../../../utils/createSvgIcon';

export default createSvgIcon(
  [<g key="0"><path fill="currentColor" d="M19.4857 19.4936C16.6 22.379 12.181 22.7695 8.8667 20.6839l1.3904-1.3903c2.5334 1.3618 5.7524.9809 7.8858-1.1523 2.6-2.5997 2.6-6.8279 0-9.4277-1.3048-1.295-3.0096-1.9236-4.7143-1.9236v2.8283L9.6191 5.8092 13.4286 2v2.8664c2.1904 0 4.3904.8285 6.0571 2.5045 3.3524 3.3426 3.3524 8.7706 0 12.1227m-6.0571-6.0661-5.7143 5.7137L2 13.4275l5.7143-5.7138z" /></g>,<defs key="1"></defs>,]
, 'CameraPhotoRotateFilledx');
